/**
@fileoverview - README

Since there are field (form) validations that can only be done on the backend,
we should be able to show the error message from the backend to the user.

This file contains functions related to handling error messages from the backend.

@example Showing error message from back to Formulate:
/module/lib/constants/api-error-mappings.js
const apiErrorMappings = {
  // format:
  // [field name]: { [error from API]: [error shown on UI] }
  name: { 'already exists': 'Vendor sudah terdaftar di sistem' },
}

/module/form.vue
...
data() {
  return {
    formValues: {},
    formErrors: {},
},
methods: {
  async handleSubmit(data) {
    ...
    if(res.errors) {
      this.formErrors = handleApiValidation(apiErrorMappings, res.errors)
    }
    ...
  }
}
...
<FormulateForm
  v-model="formValues"
  :errors="formErrors"
  @submit="handleSubmit"
>...</FormulateForm>
*/

/**
 * @param {Object} apiErrorMappings - error mappings from API
 * @param {Object} errors - errors from API
 * @returns {Object} - errors object with error messages from API
 * @example see this file
 */
export const handleApiValidation = (apiErrorMappings, errors) => {
  const fieldWithErrors = Object.keys(errors)
  const errorsObj = {}

  fieldWithErrors.forEach((field) => {
    errorsObj[field] = apiErrorMappings[field][errors[field][0]]
  })

  return errorsObj
}
